import { createSelector } from 'reselect';

import { configs } from '@constants/configs/configs';
import { analyzeSsapDataInconsistencies } from './analyzeSsapDataInconsistencies';

const selectSsapData = state => state.ssap.data;

const EMPTY_ANALYSIS = { issues: [], issueCount: 0 };

export const selectSsapDataInconsistencyAnalysis = createSelector(
    selectSsapData,
    data => (configs.ENV.DEVELOPMENT ? analyzeSsapDataInconsistencies(data) : EMPTY_ANALYSIS),
);

export const selectSsapDataInconsistencyIssues = createSelector(
    selectSsapDataInconsistencyAnalysis,
    ({ issues }) => issues,
);

export const selectSsapDataInconsistencyIssueCount = createSelector(
    selectSsapDataInconsistencyAnalysis,
    ({ issueCount }) => issueCount,
);

export const selectHasSsapDataInconsistencies = createSelector(
    selectSsapDataInconsistencyIssueCount,
    issueCount => issueCount > 0,
);
